import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import styles from './styles.module.css';

interface ModalProps {
  children: React.ReactNode;
  isOpen: boolean;
}

const Modal = (props: ModalProps) => {

  const node = document.createElement('div');
  const modalRoot = document.getElementById('modal-root');

  useEffect(() => {
    modalRoot?.appendChild(node);
    return () => {
      modalRoot?.removeChild(node);
    };
  });

  if (!props.isOpen) return null;
  return ReactDOM.createPortal(
    <div className={styles['modal']}>
      <div className={styles['container']}>
        {props.children}
      </div>
    </div>
    , node);
};

export default Modal;
